import { Icon, TextField, TextFieldProps } from '@taleemabad/dsm/components';
import React, { useState } from 'react';

export interface SearchFieldProps extends TextFieldProps {
  onChange?: (data: string) => void;
  onClearClick?: () => void;
  onFocus?: () => void;
  value?: string | null;
}

export const SearchField = ({
  onChange,
  onClearClick,
  onFocus,
  value,
  ...props
}: SearchFieldProps) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [forceReload, setForceReload] = useState<number>(0);

  // Sync external value changes
  React.useEffect(() => {
    if (value !== undefined) {
      setInputValue(value ?? '');
    }
  }, [value]);

  const handleTyping = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value.trim();
    setInputValue(newValue);
    if (onChange) {
      onChange(newValue);
    }
  };

  const handleClearClick = () => {
    setInputValue('');
    setForceReload((prev) => prev + 1);
    onChange?.('');
    onClearClick?.();
  };

  return (
    <TextField
      key={forceReload}
      id="search-field"
      name="search-field"
      width="100%"
      onInput={handleTyping}
      value={inputValue}
      variant={props.variant}
      type={props.type}
      onFocus={onFocus}
      {...props}
    >
      <Icon
        name={inputValue ? 'close' : 'search'}
        slot="trailing-icon"
        data-cy="clear-field-button"
        onClick={handleClearClick}
        cursor="pointer"
      />
    </TextField>
  );
};
